<template>
  <transition name="fade">
    <div class="wrap-modal" v-if="showModalStatus">
      <div class="filter" v-on:click="closeModal"></div>
      <div class="content"  @dragenter="dragEnter" v-on:mouseenter="dragEnd" v-on:mouseout="dragEnd" @drop="dragEnd">
        <div class="modal-header">
          <p class="fz18 fw500 text-dark">{{$route.path.indexOf('accounting-invoice')>=0 ? 'Create Accounting Invoice' : 'Create payment'}}</p>
          <button v-on:click="closeModal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.51375 7.57923C6.21612 7.28453 6.21612 6.80673 6.51375 6.51204C6.81138 6.21734 7.29392 6.21734 7.59155 6.51204L17.4863 16.298C17.784 16.5927 17.784 17.0705 17.4863 17.3652C17.1887 17.6599 16.7062 17.6599 16.4085 17.3652L6.51375 7.57923Z" fill="#222222"/>
              <path d="M16.4086 6.63595C16.7063 6.34126 17.1888 6.34126 17.4864 6.63596C17.7841 6.93065 17.7841 7.40845 17.4864 7.70314L7.59165 17.4891C7.29402 17.7838 6.81148 17.7838 6.51385 17.4891C6.21622 17.1944 6.21622 16.7166 6.51385 16.4219L16.4086 6.63595Z" fill="#222222"/>
            </svg>
          </button>
        </div>
        <div class="block-buttons">
          <button class="fw500 fz16 text-gray" v-on:click="typeForButton = !typeForButton" :class="{'modal-button-active': typeForButton}"><span v-if="$route.path.indexOf('accounting-invoice')>=0">Bill</span><span v-if="$route.path.indexOf('accounting-invoice')===-1">Payment</span></button>
          <button class="fw500 fz16 text-gray" v-on:click="typeForButton = !typeForButton" :class="{'modal-button-active': !typeForButton}"><span v-if="$route.path.indexOf('accounting-invoice')>=0">Invoice</span><span v-if="$route.path.indexOf('accounting-invoice')===-1">Income</span></button>
        </div>
<!--        <counterparties-drop-->
<!--            :list="getClientsFormAddModal"-->
<!--            :title="'Counterparty'"-->
<!--            :placeholder="''"-->
<!--            @select="setActiveCounterparty"-->
<!--            :class="{'error-input-drop':errorActiveCounterparty}"-->
<!--        ></counterparties-drop>-->
        <div class="block-input">
          <async-select
              v-model="activeCounterparty"
              :allowEmpty="true"
              :closeOnSelect="true"
              label="Counterparty"
              url="/client/dropdown"
              :placeholder="''"
              :params="{ordering: 'company_name', is_archived: false}"
              watchKey="company_name"
          ></async-select>
        </div>

<!--        <payment-drop-bank-and-cash-->
<!--            v-if="getPermissionsForCreatePaymentShowStroke()"-->
<!--            title="Bank and Cash Accounts"-->
<!--            :placeholder="''"-->
<!--            :list="getPaymentsCash"-->
<!--            @select="setActiveBankAccount"-->
<!--            :class="{'error-input-drop': errorActiveBankAccount}"-->
<!--        ></payment-drop-bank-and-cash>-->
        <div class="block-input">
          <bank-and-cash-select
              :placeholder="''"
              label="Bank and Cash Accounts"
              :allow-empty="true"
              :closeOnSelect="true"
              @onSetBank="setActiveBankAccount"
              @onSetRequisite="setActiveRequisiteAccount"
          ></bank-and-cash-select>
        </div>
        <div class="drag-zone" :class="{'dragMode': dragMode}">
          <svg width="157" height="97" viewBox="0 0 157 97" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.33496 93L6.43262 90.334H2.67285L1.77051 93H0.177734L3.73926 83.1357H5.39355L8.95508 93H7.33496ZM4.53223 84.7764L3.0625 89.1035H6.04297L4.57324 84.7764H4.53223ZM9.89844 84.1064H11.3818V85.8086H12.749V86.9775H11.3818V90.9424C11.3818 91.2523 11.4525 91.4801 11.5938 91.626C11.735 91.7718 11.9561 91.8447 12.2568 91.8447C12.4756 91.8447 12.6374 91.8333 12.7422 91.8105V92.9795C12.5599 93.0251 12.2865 93.0479 11.9219 93.0479C11.1973 93.0479 10.6777 92.8997 10.3633 92.6035C10.0534 92.3027 9.89844 91.8037 9.89844 91.1064V86.9775H8.85254V85.8086H9.89844V84.1064ZM14.3965 84.1064H15.8799V85.8086H17.2471V86.9775H15.8799V90.9424C15.8799 91.2523 15.9505 91.4801 16.0918 91.626C16.2331 91.7718 16.4541 91.8447 16.7549 91.8447C16.9736 91.8447 17.1354 91.8333 17.2402 91.8105V92.9795C17.0579 93.0251 16.7845 93.0479 16.4199 93.0479C15.6953 93.0479 15.1758 92.8997 14.8613 92.6035C14.5514 92.3027 14.3965 91.8037 14.3965 91.1064V86.9775H13.3506V85.8086H14.3965V84.1064ZM20.8701 91.9541C21.3896 91.9541 21.8249 91.7969 22.1758 91.4824C22.5312 91.1634 22.709 90.7715 22.709 90.3066V89.7393L20.9385 89.8486C20.4964 89.8805 20.1546 89.9899 19.9131 90.1768C19.6761 90.359 19.5576 90.6051 19.5576 90.915C19.5576 91.2295 19.6761 91.4824 19.9131 91.6738C20.1546 91.8607 20.4736 91.9541 20.8701 91.9541ZM20.46 93.123C19.7536 93.123 19.1771 92.9225 18.7305 92.5215C18.2884 92.1204 18.0674 91.5986 18.0674 90.9561C18.0674 90.3271 18.2998 89.8281 18.7646 89.459C19.2295 89.0853 19.888 88.8757 20.7402 88.8301L22.709 88.7139V88.1602C22.709 87.7591 22.5814 87.4469 22.3262 87.2236C22.071 86.9958 21.7178 86.8818 21.2666 86.8818C20.8473 86.8818 20.5055 86.9753 20.2412 87.1621C19.9814 87.349 19.8174 87.6064 19.749 87.9346H18.3545C18.3955 87.2692 18.6826 86.7269 19.2158 86.3076C19.749 85.8883 20.4508 85.6787 21.3213 85.6787C22.1917 85.6787 22.8844 85.8929 23.3994 86.3213C23.9189 86.7497 24.1787 87.3239 24.1787 88.0439V93H22.7637V91.8174H22.7295C22.5244 92.2139 22.2122 92.5306 21.793 92.7676C21.3783 93.0046 20.9339 93.123 20.46 93.123ZM31.7871 88.2832H30.3789C30.3014 87.8776 30.1146 87.5472 29.8184 87.292C29.5267 87.0368 29.1507 86.9092 28.6904 86.9092C28.1162 86.9092 27.6559 87.1348 27.3096 87.5859C26.9678 88.0326 26.7969 88.6387 26.7969 89.4043C26.7969 90.1836 26.9678 90.7943 27.3096 91.2363C27.6559 91.6784 28.1208 91.8994 28.7041 91.8994C29.1553 91.8994 29.5244 91.7832 29.8115 91.5508C30.1032 91.3138 30.2923 90.9857 30.3789 90.5664H31.8008C31.7233 91.3366 31.3997 91.9587 30.8301 92.4326C30.265 92.902 29.5518 93.1367 28.6904 93.1367C27.6559 93.1367 26.8311 92.804 26.2158 92.1387C25.6006 91.4688 25.293 90.5573 25.293 89.4043C25.293 88.265 25.6006 87.3604 26.2158 86.6904C26.8311 86.016 27.6514 85.6787 28.6768 85.6787C29.57 85.6787 30.2946 85.9294 30.8506 86.4307C31.4066 86.9274 31.7188 87.5449 31.7871 88.2832ZM32.9014 93V83.1357H34.3643V87.0117H34.3984C34.599 86.5879 34.8929 86.262 35.2803 86.0342C35.6676 85.8018 36.1325 85.6855 36.6748 85.6855C37.4587 85.6855 38.0739 85.9271 38.5205 86.4102C38.9717 86.8932 39.1973 87.5449 39.1973 88.3652V93H37.7139V88.6523C37.7139 88.1146 37.5794 87.6976 37.3105 87.4014C37.0462 87.1051 36.6566 86.957 36.1416 86.957C35.5993 86.957 35.1686 87.1302 34.8496 87.4766C34.5352 87.8184 34.3779 88.2741 34.3779 88.8438V93H32.9014ZM43.9004 93V86.9775H42.9092V85.8223H43.9004V85.1182C43.9004 84.4163 44.0713 83.8991 44.4131 83.5664C44.7549 83.2337 45.2904 83.0674 46.0195 83.0674C46.3158 83.0674 46.5915 83.0902 46.8467 83.1357V84.2295C46.7008 84.2021 46.5208 84.1885 46.3066 84.1885C45.6777 84.1885 45.3633 84.5075 45.3633 85.1455V85.8223H46.8193V86.9775H45.3838V93H43.9004ZM48.0293 93V85.8086H49.5059V93H48.0293ZM49.376 84.5098C49.2074 84.6738 49.0046 84.7559 48.7676 84.7559C48.5306 84.7559 48.3278 84.6738 48.1592 84.5098C47.9951 84.3457 47.9131 84.1475 47.9131 83.915C47.9131 83.6781 47.9951 83.4775 48.1592 83.3135C48.3278 83.1494 48.5306 83.0674 48.7676 83.0674C49.0091 83.0674 49.2119 83.1494 49.376 83.3135C49.5446 83.4775 49.6289 83.6781 49.6289 83.915C49.6289 84.1475 49.5446 84.3457 49.376 84.5098ZM51.0713 93V83.1357H52.5479V93H51.0713ZM58.3242 87.3877C58.0007 87.0413 57.5837 86.8682 57.0732 86.8682C56.5628 86.8682 56.139 87.0436 55.8018 87.3945C55.4645 87.7409 55.2777 88.1898 55.2412 88.7412H58.8369C58.8187 88.1852 58.6478 87.734 58.3242 87.3877ZM58.8301 90.8877H60.2314C60.1266 91.5485 59.7894 92.0885 59.2197 92.5078C58.6501 92.9271 57.9551 93.1367 57.1348 93.1367C56.082 93.1367 55.2526 92.8063 54.6465 92.1455C54.0449 91.4801 53.7441 90.5778 53.7441 89.4385C53.7441 88.3083 54.0449 87.3991 54.6465 86.7109C55.2526 86.0228 56.0615 85.6787 57.0732 85.6787C58.0667 85.6787 58.8551 86.0046 59.4385 86.6562C60.0218 87.3034 60.3135 88.1738 60.3135 89.2676V89.7734H55.2344V89.8623C55.2344 90.4912 55.4098 90.9948 55.7607 91.373C56.1117 91.7513 56.5811 91.9404 57.1689 91.9404C57.5837 91.9404 57.9391 91.8447 58.2354 91.6533C58.5316 91.4619 58.7298 91.2067 58.8301 90.8877ZM64.7363 84.1064H66.2197V85.8086H67.5869V86.9775H66.2197V90.9424C66.2197 91.2523 66.2904 91.4801 66.4316 91.626C66.5729 91.7718 66.7939 91.8447 67.0947 91.8447C67.3135 91.8447 67.4753 91.8333 67.5801 91.8105V92.9795C67.3978 93.0251 67.1243 93.0479 66.7598 93.0479C66.0352 93.0479 65.5156 92.8997 65.2012 92.6035C64.8913 92.3027 64.7363 91.8037 64.7363 91.1064V86.9775H63.6904V85.8086H64.7363V84.1064ZM74.1973 92.1387C73.5775 92.804 72.7503 93.1367 71.7158 93.1367C70.6813 93.1367 69.8542 92.804 69.2344 92.1387C68.6146 91.4688 68.3047 90.5573 68.3047 89.4043C68.3047 88.2559 68.6146 87.349 69.2344 86.6836C69.8542 86.0137 70.6813 85.6787 71.7158 85.6787C72.7503 85.6787 73.5775 86.0137 74.1973 86.6836C74.8171 87.349 75.127 88.2559 75.127 89.4043C75.127 90.5573 74.8171 91.4688 74.1973 92.1387ZM71.7158 91.9199C72.3037 91.9199 72.7686 91.6989 73.1104 91.2568C73.4521 90.8148 73.623 90.1973 73.623 89.4043C73.623 88.6159 73.4499 88.0007 73.1035 87.5586C72.7617 87.1165 72.2992 86.8955 71.7158 86.8955C71.1325 86.8955 70.6676 87.1165 70.3213 87.5586C69.9795 88.0007 69.8086 88.6159 69.8086 89.4043C69.8086 90.1973 69.9795 90.8148 70.3213 91.2568C70.6676 91.6989 71.1325 91.9199 71.7158 91.9199ZM79.543 84.1064H81.0264V85.8086H82.3936V86.9775H81.0264V90.9424C81.0264 91.2523 81.097 91.4801 81.2383 91.626C81.3796 91.7718 81.6006 91.8447 81.9014 91.8447C82.1201 91.8447 82.2819 91.8333 82.3867 91.8105V92.9795C82.2044 93.0251 81.931 93.0479 81.5664 93.0479C80.8418 93.0479 80.3223 92.8997 80.0078 92.6035C79.6979 92.3027 79.543 91.8037 79.543 91.1064V86.9775H78.4971V85.8086H79.543V84.1064ZM83.665 93V83.1357H85.1279V87.0117H85.1621C85.3626 86.5879 85.6566 86.262 86.0439 86.0342C86.4313 85.8018 86.8962 85.6855 87.4385 85.6855C88.2223 85.6855 88.8376 85.9271 89.2842 86.4102C89.7354 86.8932 89.9609 87.5449 89.9609 88.3652V93H88.4775V88.6523C88.4775 88.1146 88.3431 87.6976 88.0742 87.4014C87.8099 87.1051 87.4202 86.957 86.9053 86.957C86.363 86.957 85.9323 87.1302 85.6133 87.4766C85.2988 87.8184 85.1416 88.2741 85.1416 88.8438V93H83.665ZM91.4375 93V85.8086H92.9141V93H91.4375ZM92.7842 84.5098C92.6156 84.6738 92.4128 84.7559 92.1758 84.7559C91.9388 84.7559 91.736 84.6738 91.5674 84.5098C91.4033 84.3457 91.3213 84.1475 91.3213 83.915C91.3213 83.6781 91.4033 83.4775 91.5674 83.3135C91.736 83.1494 91.9388 83.0674 92.1758 83.0674C92.4173 83.0674 92.6201 83.1494 92.7842 83.3135C92.9528 83.4775 93.0371 83.6781 93.0371 83.915C93.0371 84.1475 92.9528 84.3457 92.7842 84.5098ZM94.2949 87.8457C94.2949 87.2031 94.5547 86.6813 95.0742 86.2803C95.5938 85.8792 96.2728 85.6787 97.1113 85.6787C97.9089 85.6787 98.5628 85.8815 99.0732 86.2871C99.5882 86.6882 99.8571 87.21 99.8799 87.8525H98.4922C98.4557 87.5244 98.3122 87.2669 98.0615 87.0801C97.8109 86.8932 97.4805 86.7998 97.0703 86.7998C96.6693 86.7998 96.3457 86.8887 96.0996 87.0664C95.8581 87.2441 95.7373 87.4743 95.7373 87.7568C95.7373 88.1943 96.1042 88.5042 96.8379 88.6865L98.0479 88.9668C98.7725 89.14 99.2852 89.377 99.5859 89.6777C99.8913 89.974 100.044 90.3887 100.044 90.9219C100.044 91.5781 99.766 92.1113 99.21 92.5215C98.6585 92.9316 97.9408 93.1367 97.0566 93.1367C96.2135 93.1367 95.5254 92.9362 94.9922 92.5352C94.4635 92.1341 94.1696 91.6009 94.1104 90.9355H95.5732C95.6325 91.2819 95.7943 91.5485 96.0586 91.7354C96.3229 91.9176 96.6784 92.0088 97.125 92.0088C97.5671 92.0088 97.9157 91.9245 98.1709 91.7559C98.4307 91.5827 98.5605 91.3503 98.5605 91.0586C98.5605 90.8262 98.4831 90.6416 98.3281 90.5049C98.1732 90.3682 97.9089 90.252 97.5352 90.1562L96.25 89.8418C94.9466 89.5273 94.2949 88.862 94.2949 87.8457ZM107.782 85.6924C108.698 85.6924 109.432 86.0273 109.983 86.6973C110.535 87.3672 110.811 88.2695 110.811 89.4043C110.811 90.5391 110.537 91.4437 109.99 92.1182C109.443 92.7881 108.716 93.123 107.81 93.123C107.299 93.123 106.846 93.0068 106.449 92.7744C106.057 92.542 105.757 92.223 105.547 91.8174H105.513V95.3789H104.036V85.8086H105.465V87.0459H105.492C105.706 86.6266 106.014 86.2962 106.415 86.0547C106.816 85.8132 107.272 85.6924 107.782 85.6924ZM107.393 91.8721C107.976 91.8721 108.438 91.651 108.78 91.209C109.122 90.7624 109.293 90.1608 109.293 89.4043C109.293 88.6523 109.122 88.0531 108.78 87.6064C108.438 87.1598 107.976 86.9365 107.393 86.9365C106.827 86.9365 106.372 87.1621 106.025 87.6133C105.679 88.0645 105.506 88.6615 105.506 89.4043C105.506 90.1517 105.677 90.751 106.019 91.2021C106.365 91.6488 106.823 91.8721 107.393 91.8721ZM114.468 91.9541C114.987 91.9541 115.423 91.7969 115.773 91.4824C116.129 91.1634 116.307 90.7715 116.307 90.3066V89.7393L114.536 89.8486C114.094 89.8805 113.752 89.9899 113.511 90.1768C113.274 90.359 113.155 90.6051 113.155 90.915C113.155 91.2295 113.274 91.4824 113.511 91.6738C113.752 91.8607 114.071 91.9541 114.468 91.9541ZM114.058 93.123C113.351 93.123 112.775 92.9225 112.328 92.5215C111.886 92.1204 111.665 91.5986 111.665 90.9561C111.665 90.3271 111.897 89.8281 112.362 89.459C112.827 89.0853 113.486 88.8757 114.338 88.8301L116.307 88.7139V88.1602C116.307 87.7591 116.179 87.4469 115.924 87.2236C115.669 86.9958 115.315 86.8818 114.864 86.8818C114.445 86.8818 114.103 86.9753 113.839 87.1621C113.579 87.349 113.415 87.6064 113.347 87.9346H111.952C111.993 87.2692 112.28 86.7269 112.813 86.3076C113.347 85.8883 114.049 85.6787 114.919 85.6787C115.789 85.6787 116.482 85.8929 116.997 86.3213C117.517 86.7497 117.776 87.3239 117.776 88.0439V93H116.361V91.8174H116.327C116.122 92.2139 115.81 92.5306 115.391 92.7676C114.976 93.0046 114.532 93.123 114.058 93.123ZM119.923 95.6797C119.645 95.6797 119.444 95.6683 119.321 95.6455V94.4492C119.394 94.4674 119.554 94.4766 119.8 94.4766C120.146 94.4766 120.417 94.3968 120.613 94.2373C120.809 94.0824 120.964 93.8203 121.078 93.4512C121.078 93.4466 121.101 93.3714 121.146 93.2256L121.208 93.0068L118.61 85.8086H120.21L122.035 91.6602H122.056L123.881 85.8086H125.439L122.739 93.376C122.434 94.2464 122.076 94.848 121.666 95.1807C121.256 95.5133 120.675 95.6797 119.923 95.6797ZM126.308 93V85.8086H127.716V87.0186H127.75C127.914 86.613 128.176 86.2894 128.536 86.0479C128.896 85.8063 129.315 85.6855 129.794 85.6855C130.291 85.6855 130.712 85.8086 131.059 86.0547C131.41 86.3008 131.658 86.6471 131.804 87.0938H131.838C132.025 86.6562 132.316 86.3122 132.713 86.0615C133.114 85.8109 133.57 85.6855 134.08 85.6855C134.791 85.6855 135.361 85.902 135.789 86.335C136.217 86.7679 136.432 87.3421 136.432 88.0576V93H134.948V88.4131C134.948 87.9482 134.827 87.5882 134.586 87.333C134.349 87.0778 134.012 86.9502 133.574 86.9502C133.137 86.9502 132.779 87.096 132.501 87.3877C132.228 87.6794 132.091 88.0531 132.091 88.5088V93H130.642V88.3037C130.642 87.889 130.519 87.5609 130.272 87.3193C130.026 87.0732 129.696 86.9502 129.281 86.9502C128.844 86.9502 128.484 87.1029 128.201 87.4082C127.923 87.709 127.784 88.0918 127.784 88.5566V93H126.308ZM142.119 87.3877C141.796 87.0413 141.379 86.8682 140.868 86.8682C140.358 86.8682 139.934 87.0436 139.597 87.3945C139.259 87.7409 139.073 88.1898 139.036 88.7412H142.632C142.614 88.1852 142.443 87.734 142.119 87.3877ZM142.625 90.8877H144.026C143.922 91.5485 143.584 92.0885 143.015 92.5078C142.445 92.9271 141.75 93.1367 140.93 93.1367C139.877 93.1367 139.048 92.8063 138.441 92.1455C137.84 91.4801 137.539 90.5778 137.539 89.4385C137.539 88.3083 137.84 87.3991 138.441 86.7109C139.048 86.0228 139.856 85.6787 140.868 85.6787C141.862 85.6787 142.65 86.0046 143.233 86.6562C143.817 87.3034 144.108 88.1738 144.108 89.2676V89.7734H139.029V89.8623C139.029 90.4912 139.205 90.9948 139.556 91.373C139.907 91.7513 140.376 91.9404 140.964 91.9404C141.379 91.9404 141.734 91.8447 142.03 91.6533C142.326 91.4619 142.525 91.2067 142.625 90.8877ZM145.257 93V85.8086H146.665V87.0117H146.699C146.9 86.5924 147.191 86.2666 147.574 86.0342C147.957 85.8018 148.42 85.6855 148.962 85.6855C149.75 85.6855 150.363 85.9225 150.801 86.3965C151.238 86.8659 151.457 87.5153 151.457 88.3447V93H149.974V88.6318C149.974 88.085 149.844 87.6702 149.584 87.3877C149.329 87.1006 148.948 86.957 148.442 86.957C147.923 86.957 147.508 87.1257 147.198 87.4629C146.888 87.8001 146.733 88.249 146.733 88.8096V93H145.257ZM153.316 84.1064H154.8V85.8086H156.167V86.9775H154.8V90.9424C154.8 91.2523 154.87 91.4801 155.012 91.626C155.153 91.7718 155.374 91.8447 155.675 91.8447C155.894 91.8447 156.055 91.8333 156.16 91.8105V92.9795C155.978 93.0251 155.704 93.0479 155.34 93.0479C154.615 93.0479 154.096 92.8997 153.781 92.6035C153.471 92.3027 153.316 91.8037 153.316 91.1064V86.9775H152.271V85.8086H153.316V84.1064Z" fill="#094172"/>
            <path d="M88.6785 46.9363C88.8935 47.1514 89.1744 47.2565 89.4548 47.2565C89.7357 47.2565 90.0165 47.1492 90.2312 46.9363C90.6591 46.5084 90.6591 45.8133 90.2312 45.3854L78.7795 33.9358C78.778 33.9344 78.7765 33.9329 78.7751 33.9314L78.7115 33.8678C78.319 33.4754 77.6827 33.4754 77.2903 33.8678L77.2289 33.9292C77.2274 33.9307 77.2259 33.9321 77.2245 33.9336L65.7701 45.3857C65.3422 45.8136 65.3422 46.5088 65.7701 46.9367C66.198 47.3646 66.8932 47.3646 67.3211 46.9367L76.9043 37.3557V56.6758C76.9043 57.2812 77.3958 57.7723 78.0009 57.7723C78.6063 57.7723 79.0974 57.2808 79.0974 56.6758V37.3553L88.6785 46.9363Z" fill="#094172"/>
            <path d="M99.53 26.8769C96.8299 19.281 89.7012 14.2227 81.5829 14.2227C73.9322 14.2227 67.0509 18.8244 64.0744 25.7998C62.6727 25.1506 61.1482 24.8127 59.5999 24.8127C53.6994 24.8127 48.8958 29.6078 48.8848 35.5058C45.8164 37.853 44 41.4985 44 45.3768C44 52.2118 49.5759 57.7722 56.6127 57.7744C56.6917 57.7744 56.7707 57.7766 56.841 57.7766C56.9156 57.7766 56.9814 57.7766 57.034 57.7722H68.5934C69.1989 57.7722 69.69 57.2807 69.69 56.6756C69.69 56.0706 69.1985 55.5791 68.5934 55.5791H56.9766C56.8693 55.5857 56.7571 55.5813 56.6498 55.5791L56.4259 55.5769C50.7842 55.5769 46.1935 51.0012 46.1935 45.375C46.1935 42.0124 47.8518 38.8602 50.6287 36.9475L51.1331 36.4454L51.0783 35.5286C51.0783 30.8301 54.9015 27.007 59.5999 27.007C61.1747 27.007 62.7212 27.45 64.0722 28.2859L65.2324 29.0053L65.6842 27.7154C68.0486 20.9573 74.4362 16.4191 81.5847 16.4191C88.9638 16.4191 95.4212 21.1418 97.6518 28.1738L97.8559 28.8164L98.5227 28.9237C105.059 29.981 109.806 35.5525 109.806 42.1724C109.806 49.5665 103.776 55.5809 96.3667 55.5809H87.4062C86.8008 55.5809 86.3096 56.0724 86.3096 56.6775C86.3096 57.2826 86.8011 57.7741 87.4062 57.7741H96.3667C104.987 57.7741 112 50.7748 112 42.172C111.998 34.6922 106.793 28.3642 99.53 26.8769Z" fill="#094172"/>
          </svg>
          <input type="file" multiple v-on:change="testFile">
        </div>
        <div class="block-inputs">
          <div>
            <p class="fz13 text-gray">Payment Amount</p>
            <input-format-number v-model="paymentAmount" :input-class="'h36 pr60' + ( errorPaymentAmount ? ' error-input' : '')" @input="inputCurrency"></input-format-number>

<!--            <input :class="{'error-input': errorPaymentAmount}" type="text" class="h36 pr60" v-model="paymentAmount" @input="inputCurrency">-->
            <counterparties-drop
                :removeSelectItemBeforeClick="false"
                class="valute-drop"
                title=""
                :key="showModalStatus"
                :placeholder="''"
                :list="valutaList"
                @select="setActiveValuePayment"
                :activeItem="activeValute"
                :is-disabled="noSetCurrency"
            ></counterparties-drop>
          </div>
          <div>
            <p class="fz13 text-gray">Converted Amount in USD</p>
            <input-format-number v-model="paymentAmountConvert" :input-class="'h36' + ( errorPaymentAmountConvert ? ' error-input' : '')" :disabled="activeValuePayment.name === 'USD'"></input-format-number>
<!--            <input :class="{'error-input': errorPaymentAmountConvert}" :disabled="activeValuePayment.name === 'USD'" type="text" class="h36" v-model="paymentAmountConvert" @input="paymentAmountConvert = checkNum(paymentAmountConvert)">-->
          </div>
        </div>
        <div class="block-input">
          <p class="fz13 text-gray">Due Date</p>
          <date-picker
              value-type="date"
              v-model="dueDate"
              type="datetime"
              class="datepick"
              placeholder="Set due date"
              :show-time-panel="showTimePanel"
              ref="datePickDue"
              format="D MMM YYYY HH:mm"
              v-on:keydown.enter="clickEnterDueDate"
          >
            <template v-slot:footer>
              <button class="mx-btn mx-btn-text" @click="showTimePanel= !showTimePanel">
                {{ showTimePanel ? 'Select date' : 'Select time' }}
              </button>
            </template>
          </date-picker>
        </div>
<!--        <counterparties-drop-->
<!--            v-if="getPermissionsForCreatePaymentShowStroke()"-->
<!--            title="Account name"-->
<!--            :is-multiple="true"-->
<!--            :placeholder="''"-->
<!--            :list="getPaymentsAccount"-->
<!--            @select="setActiveAccountName"-->
<!--            :class="{'error-input-drop':errorAccountName}"-->
<!--        ></counterparties-drop>-->
        <div class="block-input">
          <async-select
              v-model="activeAccountName"
              :allowEmpty="true"
              label="Account name"
              :beforeWatchKey="'account_id'"
              url="/payment/account"
              :placeholder="''"
              :params="{is_archive: false}"
              :is-multiple="true"
          ></async-select>
        </div>

<!--        <counterparties-drop-->
<!--            title="Bank and Cash Accounts"-->
<!--            :list="getPaymentsCash"-->
<!--            @select="setActiveBankAccount"-->
<!--            :class="{'error-input-drop': errorActiveBankAccount}"-->
<!--        ></counterparties-drop>-->
<!--        <counterparties-drop-->
<!--            title="Real Account"-->
<!--            :placeholder="''"-->
<!--            @select="setActiveRealAccount"-->
<!--            :list="getClientsFormAddModal"-->
<!--        ></counterparties-drop>-->
        <div class="block-input">
          <async-select
              v-model="activeRealAccount"
              :allowEmpty="true"
              :closeOnSelect="true"
              label="Real Account"
              url="/client/dropdown"
              :placeholder="''"
              :params="{ordering: 'company_name', is_archived: false}"
              watchKey="company_name"
          ></async-select>
        </div>
<!--        <payment-drop-vessel-->
<!--            title="Vessel"-->
<!--            :active-item="defaultActiveVessel"-->
<!--            :list="getShipContracts()"-->
<!--            @select="setActiveVessel"-->
<!--        ></payment-drop-vessel>-->
        <div class="block-input">
          <async-select
              :id="'sd2sd22'"
              label="Vessel"
              url="/contract/dropdown"
              :params="{is_archive: false, contract_type: ['SHIP']}"
              :allowEmpty="true"
              :placeholder="''"
              :closeOnSelect="true"
              v-model="activeVessel"
              :after-watch-key-brackets="'cp_date'"
          />
        </div>

<!--        <counterparties-drop-->
<!--            title="Vessel"-->
<!--            :active-item="defaultActiveVessel"-->
<!--            :list="getShipContracts()"-->
<!--            @select="setActiveVessel"-->
<!--        ></counterparties-drop>-->
<!--        <payment-drop-vessel-->
<!--            title="Settled Vessel"-->
<!--            :list="getShipContracts()"-->
<!--            @select="setActiveSettledVessel"-->
<!--        ></payment-drop-vessel>-->
        <div class="block-input">
          <async-select
              :id="'sd2sd22'"
              :placeholder="'Choose Counterparty or Real Account'"
              label="Settled Vessel"
              url="/contract/dropdown"
              :allowEmpty="true"
                    :params=" {is_archive: false, contract_type: ['SHIP'], ordering: 'name'}"
          :closeOnSelect="true"
              v-model="activeSettledVessel"
              :key="keyRenderVessel+'sd2'"
              :after-watch-key-brackets="'cp_date'"
          />
<!--          :params="(activeRealAccount || activeCounterparty) ? {is_archive: false, contract_type: ['SHIP'], ordering: 'name', owner: activeRealAccount ? activeRealAccount.id : activeCounterparty ? activeCounterparty.id : null } : {is_archive: false, contract_type: ['SHIP'], ordering: 'name'}"-->

        </div>

<!--        <counterparties-drop-->
<!--            title="Disbursements (Port)"-->
<!--            :is-multiple="true"-->
<!--            :list="getPorts()"-->
<!--            @select="setActiveDisbursements"-->
<!--        ></counterparties-drop>-->
        <async-select-port
            :placeholder="''"
            class="counterparties-drop"
            :is-multiple="true"
            v-model="port"
            id="loading_port"
            label="Disbursements (Port)"
            :allowEmpty="true"
            :closeOnSelect="false"
        />
<!--        <pre>{{ports}}</pre>-->
        <counterparties-drop
            v-if="$route.name !== 'Accounting Invoice'"
            title="Statement Member"
            :placeholder="'Choose Settled Vessel'"
            :list="getCPDateListStatement()"
            :active-item="activeCPDateDefStatement"
            :key="keyRenderStatement+'sd'"
            @select="selectCPDateStatement"
            :dontSelect="true"
        ></counterparties-drop>
        <counterparties-drop
            :key="keyRender"
            :placeholder="'Choose Vessel'"
            title="CP Date"
            :list="getCPDateList()"
            :active-item="activeCPDateDef"
            @select="selectCPDate"
        ></counterparties-drop>

        <linked-wrap 
          class="block-input" 
          :linkedPayments="linked_payments" 
          :linkedInvoices="linked_invoices" 
          :linkedOwners="linked_owners" 
          :linkedType="$route.path.indexOf('accounting-invoice')>=0 ? 'Invoices' : 'Payments'"
        />

        <div class="block-input">
          <p class="fz13 text-gray">Remark</p>
          <textarea v-model="remark" maxlength="2000"></textarea>
        </div>
        <div class="block-input" v-if="getPermissionForAddFile()">
          <p class="fz13 text-gray">Attachments</p>
          <div class="file-block">
            <vue-dropzone :options="dropzoneOptions" :useCustomSlot=true ref="dropzone" id="dropzone">
              <div class="dropzone-custom-content">
                <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                <div class="subtitle">...or click to select a file from your computer</div>
              </div>
            </vue-dropzone>
          </div>
        </div>
        <div class="bottom-panel">
          <button class="blue-button-text" v-on:click="closeModal">Cancel</button>
          <button class="blue-button fz14 fw500 buttonW180 h32" v-on:click="createPayment">Create</button>
        </div>
<!--        <pre>{{activeValuePayment}}</pre>-->
<!--        {{clients}}-->
<!--s-->
      </div>
    </div>

  </transition>
</template>

<script>
import linkedWrap from '@/components/entries/linked/linkedWrap'
import CounterpartiesDrop from "@/components/counterparties/counterpartiesAdd/counterpartiesDrop";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {mapActions, mapGetters, mapState} from "vuex";
import Vue from 'vue';

import moment from 'moment';
Vue.prototype.$moment = moment;

import AsyncSelectPort from "@/components/reuse/asyncSelectPort";
import AsyncSelect from "@/components/reuse/asyncSelect";
import BankAndCashSelect from "@/components/reuse/bankAndCashSelect";
import InputFormatNumber from "@/components/reuse/inputFormatNumber";
export default {
  name: "payment-modal-create",
  props: ["cashFlow"],

  components: {InputFormatNumber, BankAndCashSelect, AsyncSelect, linkedWrap, AsyncSelectPort, CounterpartiesDrop, DatePicker, vueDropzone: vue2Dropzone,},
  computed: {
    ...mapGetters(["getPermissionsByType", "getDataContractV", "getContracts", "getPaymentsAccount", "getPaymentsCash",]),
    ...mapState({
      // clientsType: state => state.counterpartiesType.clientsType,
      // clientsSubtype: state => state.counterpartiesType.clientsSubtype,
      ports: state => state.ports.ports,
      clients: state => state.counterparties.clientsDrop,
    }),
    getClientsFormAddModal() {
      let clients = [];
      clients = this.clients.map(a=> {
        return {id: a.id, name: a.company_name}
      })
      return clients
    },

  },

  data() {
    return {
      keyRenderVessel: -834,
      keyRenderStatement: -234,
      activeCPDateDefStatement: null,
      port: [],
      activeCounterparty: null,
      remark: "",
      activeCPDateDef: null,
      paymentAmountConvert: "",
      paymentAmount: "",
      activeValute: {'name': 'USD','id': 'USD'},
      showModalStatus: false,
      activeValuePayment: {'name': 'USD','id': 'USD'},
      typeForButton: true,
      counterpartiesList: [
        {name: "1234"}
      ],
      accountNameList: [
        {name: "1234"}
      ],
      valutaList: [
        {
          "name": "USD",
          "id": "USD"
        },
        {
          "name": "ZMW",
          "id": "ZMW"
        },
        {
          "name": "ZAR",
          "id": "ZAR"
        },
        {
          "name": "YER",
          "id": "YER"
        },
        {
          "name": "XPF",
          "id": "XPF"
        },
        {
          "name": "XOF",
          "id": "XOF"
        },
        {
          "name": "XCD",
          "id": "XCD"
        },
        {
          "name": "XAF",
          "id": "XAF"
        },
        {
          "name": "WST",
          "id": "WST"
        },
        {
          "name": "VUV",
          "id": "VUV"
        },
        {
          "name": "VND",
          "id": "VND"
        },
        {
          "name": "VES",
          "id": "VES"
        },
        {
          "name": "UZS",
          "id": "UZS"
        },
        {
          "name": "UYU",
          "id": "UYU"
        },
        {
          "name": "UGX",
          "id": "UGX"
        },
        {
          "name": "UAH",
          "id": "UAH"
        },
        {
          "name": "TZS",
          "id": "TZS"
        },
        {
          "name": "TWD",
          "id": "TWD"
        },
        {
          "name": "TVD",
          "id": "TVD"
        },
        {
          "name": "TTD",
          "id": "TTD"
        },
        {
          "name": "TRY",
          "id": "TRY"
        },
        {
          "name": "TOP",
          "id": "TOP"
        },
        {
          "name": "TND",
          "id": "TND"
        },
        {
          "name": "TMT",
          "id": "TMT"
        },
        {
          "name": "TJS",
          "id": "TJS"
        },
        {
          "name": "THB",
          "id": "THB"
        },
        {
          "name": "SZL",
          "id": "SZL"
        },
        {
          "name": "SYP",
          "id": "SYP"
        },
        {
          "name": "STN",
          "id": "STN"
        },
        {
          "name": "SSP",
          "id": "SSP"
        },
        {
          "name": "SRD",
          "id": "SRD"
        },
        {
          "name": "SOS",
          "id": "SOS"
        },
        {
          "name": "SLL",
          "id": "SLL"
        },
        {
          "name": "SHP",
          "id": "SHP"
        },
        {
          "name": "SGD",
          "id": "SGD"
        },
        {
          "name": "SEK",
          "id": "SEK"
        },
        {
          "name": "SDG",
          "id": "SDG"
        },
        {
          "name": "SCR",
          "id": "SCR"
        },
        {
          "name": "SBD",
          "id": "SBD"
        },
        {
          "name": "SAR",
          "id": "SAR"
        },
        {
          "name": "RWF",
          "id": "RWF"
        },
        {
          "name": "RUB",
          "id": "RUB"
        },
        {
          "name": "RSD",
          "id": "RSD"
        },
        {
          "name": "RON",
          "id": "RON"
        },
        {
          "name": "QAR",
          "id": "QAR"
        },
        {
          "name": "PYG",
          "id": "PYG"
        },
        {
          "name": "PRB",
          "id": "PRB"
        },
        {
          "name": "PND",
          "id": "PND"
        },
        {
          "name": "PLN",
          "id": "PLN"
        },
        {
          "name": "PKR",
          "id": "PKR"
        },
        {
          "name": "PHP",
          "id": "PHP"
        },
        {
          "name": "PGK",
          "id": "PGK"
        },
        {
          "name": "PEN",
          "id": "PEN"
        },
        {
          "name": "PAB",
          "id": "PAB"
        },
        {
          "name": "OMR",
          "id": "OMR"
        },
        {
          "name": "NZD",
          "id": "NZD"
        },
        {
          "name": "NPR",
          "id": "NPR"
        },
        {
          "name": "NOK",
          "id": "NOK"
        },
        {
          "name": "NIO",
          "id": "NIO"
        },
        {
          "name": "NGN",
          "id": "NGN"
        },
        {
          "name": "NAD",
          "id": "NAD"
        },
        {
          "name": "MZN",
          "id": "MZN"
        },
        {
          "name": "MYR",
          "id": "MYR"
        },
        {
          "name": "MXN",
          "id": "MXN"
        },
        {
          "name": "MWK",
          "id": "MWK"
        },
        {
          "name": "MVR",
          "id": "MVR"
        },
        {
          "name": "MUR",
          "id": "MUR"
        },
        {
          "name": "MRU",
          "id": "MRU"
        },
        {
          "name": "MOP",
          "id": "MOP"
        },
        {
          "name": "MNT",
          "id": "MNT"
        },
        {
          "name": "MMK",
          "id": "MMK"
        },
        {
          "name": "MKD",
          "id": "MKD"
        },
        {
          "name": "MGA",
          "id": "MGA"
        },
        {
          "name": "MDL",
          "id": "MDL"
        },
        {
          "name": "MAD",
          "id": "MAD"
        },
        {
          "name": "LYD",
          "id": "LYD"
        },
        {
          "name": "LSL",
          "id": "LSL"
        },
        {
          "name": "LRD",
          "id": "LRD"
        },
        {
          "name": "LKR",
          "id": "LKR"
        },
        {
          "name": "LBP",
          "id": "LBP"
        },
        {
          "name": "LAK",
          "id": "LAK"
        },
        {
          "name": "KZT",
          "id": "KZT"
        },
        {
          "name": "KYD",
          "id": "KYD"
        },
        {
          "name": "KWD",
          "id": "KWD"
        },
        {
          "name": "KRW",
          "id": "KRW"
        },
        {
          "name": "KPW",
          "id": "KPW"
        },
        {
          "name": "KMF",
          "id": "KMF"
        },
        {
          "name": "KHR",
          "id": "KHR"
        },
        {
          "name": "KGS",
          "id": "KGS"
        },
        {
          "name": "KES",
          "id": "KES"
        },
        {
          "name": "JPY",
          "id": "JPY"
        },
        {
          "name": "JOD",
          "id": "JOD"
        },
        {
          "name": "JMD",
          "id": "JMD"
        },
        {
          "name": "ISK",
          "id": "ISK"
        },
        {
          "name": "IRR",
          "id": "IRR"
        },
        {
          "name": "IQD",
          "id": "IQD"
        },
        {
          "name": "INR",
          "id": "INR"
        },
        {
          "name": "ILS",
          "id": "ILS"
        },
        {
          "name": "IDR",
          "id": "IDR"
        },
        {
          "name": "HUF",
          "id": "HUF"
        },
        {
          "name": "HTG",
          "id": "HTG"
        },
        {
          "name": "HRK",
          "id": "HRK"
        },
        {
          "name": "HNL",
          "id": "HNL"
        },
        {
          "name": "HKD",
          "id": "HKD"
        },
        {
          "name": "GYD",
          "id": "GYD"
        },
        {
          "name": "GTQ",
          "id": "GTQ"
        },
        {
          "name": "GNF",
          "id": "GNF"
        },
        {
          "name": "GMD",
          "id": "GMD"
        },
        {
          "name": "GIP",
          "id": "GIP"
        },
        {
          "name": "GHS",
          "id": "GHS"
        },
        {
          "name": "GGP",
          "id": "GGP"
        },
        {
          "name": "GEL",
          "id": "GEL"
        },
        {
          "name": "GBP",
          "id": "GBP"
        },
        {
          "name": "FOK",
          "id": "FOK"
        },
        {
          "name": "FKP",
          "id": "FKP"
        },
        {
          "name": "FJD",
          "id": "FJD"
        },
        {
          "name": "EUR",
          "id": "EUR"
        },
        {
          "name": "ETB",
          "id": "ETB"
        },
        {
          "name": "ERN",
          "id": "ERN"
        },
        {
          "name": "EGP",
          "id": "EGP"
        },
        {
          "name": "DZD",
          "id": "DZD"
        },
        {
          "name": "DOP",
          "id": "DOP"
        },
        {
          "name": "DKK",
          "id": "DKK"
        },
        {
          "name": "DJF",
          "id": "DJF"
        },
        {
          "name": "CZK",
          "id": "CZK"
        },
        {
          "name": "CVE",
          "id": "CVE"
        },
        {
          "name": "CUP",
          "id": "CUP"
        },
        {
          "name": "CUC",
          "id": "CUC"
        },
        {
          "name": "CRC",
          "id": "CRC"
        },
        {
          "name": "COP",
          "id": "COP"
        },
        {
          "name": "CNY",
          "id": "CNY"
        },
        {
          "name": "CLP",
          "id": "CLP"
        },
        {
          "name": "CKD",
          "id": "CKD"
        },
        {
          "name": "CHF",
          "id": "CHF"
        },
        {
          "name": "CDF",
          "id": "CDF"
        },
        {
          "name": "CAD",
          "id": "CAD"
        },
        {
          "name": "BZD",
          "id": "BZD"
        },
        {
          "name": "BYN",
          "id": "BYN"
        },
        {
          "name": "BWP",
          "id": "BWP"
        },
        {
          "name": "BTN",
          "id": "BTN"
        },
        {
          "name": "BSD",
          "id": "BSD"
        },
        {
          "name": "BRL",
          "id": "BRL"
        },
        {
          "name": "BOB",
          "id": "BOB"
        },
        {
          "name": "BND",
          "id": "BND"
        },
        {
          "name": "BMD",
          "id": "BMD"
        },
        {
          "name": "BIF",
          "id": "BIF"
        },
        {
          "name": "BHD",
          "id": "BHD"
        },
        {
          "name": "BGN",
          "id": "BGN"
        },
        {
          "name": "BDT",
          "id": "BDT"
        },
        {
          "name": "BBD",
          "id": "BBD"
        },
        {
          "name": "BAM",
          "id": "BAM"
        },
        {
          "name": "AZN",
          "id": "AZN"
        },
        {
          "name": "AWG",
          "id": "AWG"
        },
        {
          "name": "AUD",
          "id": "AUD"
        },
        {
          "name": "ARS",
          "id": "ARS"
        },
        {
          "name": "AOA",
          "id": "AOA"
        },
        {
          "name": "ANG",
          "id": "ANG"
        },
        {
          "name": "AMD",
          "id": "AMD"
        },
        {
          "name": "ALL",
          "id": "ALL"
        },
        {
          "name": "AFN",
          "id": "AFN"
        },
        {
          "name": "AED",
          "id": "AED"
        }
      ],

      dueDate: "",
      showTimePanel: false,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 200,
        addRemoveLinks: true,
      },
      activeRealAccount: null,
      activeBankAccount: null,
      activeAccountName: [],
      errorPaymentAmount: false,
      errorPaymentAmountConvert: false,
      errorActiveBankAccount: false,
      errorAccountName: false,
      errorActiveCounterparty: false,
      currency: 1,
      noSetCurrency: false,
      dragMode: false,
      activeDisbursements: [],
      activeSettledVessel: null,
      activeVessel: null,
      activeCPDate: null,
      keyRender: -919,
      defaultActiveVessel: null,
      firstStart: true,
      linked_payments: [],
      linked_owners: [],
      linked_invoices: [],
      activeRequisiteAccount: null,
    }
  },
  watch: {
    activeSettledVessel: function () {
      this.activeCPDateDefStatement = null;
      this.keyRenderStatement++;
    },
    activeCounterparty: function () {
      if(!this.activeRealAccount) {
        this.activeCPDateDefStatement = null;
        this.keyRenderStatement++;
      }
    },
    activeRealAccount: function () {
      // this.activeSettledVessel = null
      this.activeCPDateDefStatement = null;
      this.keyRenderStatement++;
    },
    activeVessel: function () {
      this.activeCPDate = null;
      this.activeCPDateDef = null;
      this.keyRender++;
      if(this.$route.path.indexOf('vessels')>=0) {
        if(this.getDataContractV !== null) {
          if(this.getDataContractV.cp_date !== null && (""+this.getDataContractV.cp_date).length !== 0) {
            this.activeCPDateDef = {name: this.getDataContractV.cp_date, id: this.getDataContractV.cp_date}
            this.activeCPDate = {name: this.getDataContractV.cp_date, id: this.getDataContractV.cp_date}
          }
        }
      }
    },

  },
  methods: {
    ...mapActions(["axiosGetAllContracts", "axiosGetCurrency","axiosGetPaymentAccount", "axiosGetClientsForDropdown", "axiosCreatePayment", "axiosGetPaymentCash"]),
    getPermissionsForCreatePaymentShowStroke() {
      // if(this.$route.path.indexOf("open/cash-flow") >= 0) {
        return this.getPermissionsByType("show_inputs_bank_and_cash_accounts_account_name_statement_member_in_the_payment_income_creation");
      // }
      // return true;
    },
    getPermissionForAddFile() {
      return this.getPermissionsByType("add_attachments_into_payments_incomes");
    },
    setActiveSettledVessel(data) {
      this.activeSettledVessel = data;
    },
    setActiveVessel(data) {
      this.activeVessel = data;
      this.activeCPDate = null;
      if(this.firstStart) {
        // this.activeCPDateDef = {name: "Unselected", id: -1}
        this.firstStart = false;
      }
      this.keyRender++;
    },
    getShipContracts() {
      let ships = this.getContracts.filter(a => a.contract_type === 'SHIP')
      ships = ships.map(a=> {
        return {name: a.name, id: a.id, is_redelivery: a.is_redelivery};
      });

      return ships;
    },
    getCPDateList() {
      let vessel = this.activeVessel
      if(vessel !== null) {
        let cp_dates = [];
        if(vessel.cp_date?.length) {
          cp_dates.push(vessel.cp_date)
        }
        // if(vessel.cargo_contracts?.length) {
        //   vessel.cargo_contracts.map(a=> {
        //     if(a.cp_date?.length) {
        //       cp_dates.push(a.cp_date)
        //     }
        //   })
        // }
        cp_dates = Array.from(new Set(cp_dates));
        cp_dates = cp_dates.map(a=> {
          return {name: moment(a, 'YYYY-MM-DD').format('DD.MM.YYYY'), id: a}
        })
        // cp_dates.push({name: "Unselected", id: -1})
        return cp_dates;
      }
      let cp_dates = [];

      // cp_dates.push({name: "Unselected", id: -1})
      return cp_dates;
    },
    getCPDateListStatement() {
      let vessel = JSON.parse(JSON.stringify(this.activeSettledVessel));
      if(vessel !== null) {
        let cp_dates = [];
        // if(vessel.cp_date?.length) {
        //   cp_dates.push(vessel.cp_date)
        // }

        if(vessel.cargo_contracts?.length) {
          if(this.activeCounterparty && !this.activeRealAccount) {
            vessel.cargo_contracts =  vessel.cargo_contracts.filter(a=> a.owner?.id === this.activeCounterparty.id)
          }
          if(this.activeRealAccount) {
            vessel.cargo_contracts =  vessel.cargo_contracts.filter(a=> a.owner?.id === this.activeRealAccount.id)
          }
          vessel.cargo_contracts.map(a=> {
            if(a.cp_date?.length) {
              cp_dates.push(a.cp_date)
            }
          })
        }
        cp_dates = Array.from(new Set(cp_dates));
        cp_dates = cp_dates.map(a=> {
          return {name: moment(a, 'YYYY-MM-DD').format('DD.MM.YYYY'), id: a}
        })
        // cp_dates.push({name: "Unselected", id: -1})
        cp_dates = cp_dates.sort((a, b) => new Date(a.name) - new Date(b.name));
        return cp_dates;
      }
      let cp_dates = [];

      // cp_dates.push({name: "Unselected", id: -1})
      return cp_dates;
    },

    selectCPDate(data) {
      console.log(2);
      this.activeCPDate = data;
    },
    selectCPDateStatement(data) {
      console.log(1);
      this.activeCPDateDefStatement = data;
    },
    dragEnter() {
      this.dragMode = true;
    },
    dragEnd() {
      this.dragMode = false;
    },
    testFile(e) {
      e.path[0].files
      console.log(this.$refs.dropzone);
      for(let i=0; i<e.path[0].files.length; i++) {
        this.$refs.dropzone.addFile(e.path[0].files[i])
      }
    },
    openModal() {
      console.log(this.getDataContractV)
      this.showModalStatus = true;
      if(this.$route.path.indexOf('vessels')>=0) {
        if(this.getDataContractV !== null) {
          console.log(this.getDataContractV);
          this.activeVessel = this.getDataContractV
          if(this.getDataContractV.cp_date !== null && (""+this.getDataContractV.cp_date).length !== 0) {
            this.activeCPDateDef = {name: this.getDataContractV.cp_date, id: this.getDataContractV.cp_date}
            this.activeCPDate = {name: this.getDataContractV.cp_date, id: this.getDataContractV.cp_date}
          }
        }
      }
      if(this.activeValuePayment.name !== 'USD') {
        this.axiosGetCurrency({currency: this.activeValuePayment.name, created_at: moment(new Date()).format('YYYY-MM-DD')}).then(response=> {
          console.log(response);
          this.currency = response.data.results[0].rate;
          this.paymentAmountConvert = (Math.round(((this.paymentAmount / this.currency)*100)))/100;
        })
      } else {
        this.currency = 1;
        this.paymentAmountConvert = (Math.round(((this.paymentAmount / this.currency)*100)))/100;
      }
    },
    inputCurrency() {
      this.paymentAmount = this.checkNum(this.paymentAmount);
      // this.paymentAmount = (Math.round(((this.paymentAmount)*10000)))/10000;
      this.paymentAmountConvert = (Math.round(((this.paymentAmount / this.currency)*100)))/100;
    },
    setActiveAccountName(data) {
      console.log(data);
      this.activeAccountName = data.map(a=> {
        return a.id;
      });
    },
    setActiveDisbursements(data) {
      console.log(data);
      this.activeDisbursements = data.map(a=> {
        return a.id;
      });
    },
    setActiveBankAccount(data) {
      this.activeBankAccount = data;
      this.activeRequisiteAccount = null;
      if(data.currency !== undefined && data.currency !== null) {
        this.noSetCurrency = true;
        // this.setActiveValuePayment({name: data.currency, id: data.currency});
        this.activeValute = {name: data.currency, id: data.currency};
      } else {
        this.noSetCurrency = false;
      }
    },
    setActiveRequisiteAccount(data) {
      this.activeRequisiteAccount = data;
      this.activeBankAccount = null;
      if(data.currency !== undefined && data.currency !== null) {
        this.noSetCurrency = true;
        // this.setActiveValuePayment({name: data.currency, id: data.currency});
        this.activeValute = {name: data.currency, id: data.currency};
      } else {
        this.noSetCurrency = false;
      }
    },
    setActiveRealAccount(data) {
      this.activeRealAccount = data;
    },
    setActiveValuePayment(data) {
      this.activeValuePayment = data;
      if(this.activeValuePayment.name !== 'USD') {
        this.axiosGetCurrency({currency: this.activeValuePayment.name, created_at: moment().format('YYYY-MM-DD')}).then(response=> {
          this.currency = response.data.results[0].rate;
          this.paymentAmountConvert = (Math.round(((this.paymentAmount / this.currency)*100)))/100;
        })
      } else {
        this.currency = 1;
        this.paymentAmountConvert = (Math.round(((this.paymentAmount / this.currency)*100)))/100;
      }
    },
    setActiveCounterparty(data) {
      this.activeCounterparty = data;
    },
    getValutaListForDrop() {
      let val = [];
      val = this.valutaList.map(a=> {
        return {name: a.name, id: a.name}
      })
      return val
    },
    checkNum(num) {
      if(num.indexOf(".")>=0) {
        let num1 = num.substring(0, num.indexOf("."));
        let num2 = num.substring(num.indexOf(".") + 1, num.length);

        num1 = num1.replace(/[^0-9]/g, "");
        num2 = num2.replace(/[^0-9]/g, "");

        if(num2.length > 4) {
          num2 = num2.substring(0, 4);
        }
        num = num1 + "." + num2;
      } else {
        num = num.replace(/[^0-9]/g, "");
      }
      return num;
    },
    clickEnterDueDate() {
      this.$refs.datePickDue.hide(false);
    },
    closeModal() {
      this.clearData();
      this.showModalStatus = false;
    },
    clearData() {
      this.activeRequisiteAccount = null;
      this.port = [];
      this.activeCounterparty = null;
      this.activeCPDateDefStatement = null;
      this.firstStart = true;
      this.defaultActiveVessel = null;
      this.activeValute= {'name': 'USD','id': 'USD'};
      this.noSetCurrency = false;
      this.showTimePanel = false;
      this.activeRealAccount = null;
      this.activeDisbursements = [];
      this.activeAccountName = [];
      this.activeBankAccount = null;
      this.activeValuePayment = {'name': 'USD','id': 'USD'};
      this.paymentAmount = "";
      this.remark = "";
      this.paymentAmountConvert = "";
      this.dueDate = "";
      this.typeForButton = true;
      this.errorPaymentAmount = false;
      this.errorActiveBankAccount = false;
      this.errorPaymentAmountConvert = false;
      this.errorAccountName = false;
      this.errorActiveCounterparty = false;
      if( this.$refs.dropzone !== undefined &&  this.$refs.dropzone !== null) {
        this.$refs.dropzone.removeAllFiles(true);
      }
      this.activeVessel = null;
      this.activeSettledVessel = null;
      this.activeCPDate = null;
    },
    createPayment() {
      // let problem = 0;
      // if(this.paymentAmount.length === 0) {
      //   // this.errorPaymentAmount = true;
      // } else {
      //   this.errorPaymentAmount = false;
      //   problem++;
      //
      // }
      // if(this.paymentAmountConvert.length === 0) {
      //   // this.errorPaymentAmountConvert = true;
      // } else {
      //   this.errorPaymentAmountConvert = false;
      //   problem++;
      //
      // }
      // if(this.activeBankAccount === null) {
      //   // this.errorActiveBankAccount = true;
      // } else {
      //   this.errorActiveBankAccount = false;
      //   problem++;
      //
      // }
      // if(this.activeAccountName.length === 0) {
      //   // this.errorAccountName = true;
      // } else {
      //   this.errorAccountName = false;
      //   problem++;
      //
      // }
      // if(this.activeCounterparty === null) {
      //   // this.errorActiveCounterparty = true;
      // } else {
      //   this.errorActiveCounterparty = false;
      //   problem++;
      //
      // }
      // console.log(problem)
      // if(problem > 0) {
        let payment_type = this.typeForButton ? "expense" : "income";
        let file = this.$refs.dropzone.getAcceptedFiles();
        let bank = null;
        let cash = null;
        if(this.activeBankAccount !== null) {
          cash = this.activeBankAccount.id;
        }
        if(this.activeRequisiteAccount !== null) {
          bank = this.activeRequisiteAccount.id;
        }
        let idReal = "";
        console.log(this.activeRealAccount)
        if(this.activeRealAccount !== null) {
          idReal = this.activeRealAccount.id;
        }
        let counterpatryID = "";
        if(this.activeCounterparty !== null) {
          counterpatryID = this.activeCounterparty.id;
        }
        let vessel = null;
        if(this.activeVessel !== null) {
          vessel = this.activeVessel.id;
        }
        let settled_ship = null;
        if(this.activeSettledVessel !== null) {
          settled_ship = this.activeSettledVessel.id;
        }
        let cp_date = "";
        if(this.activeCPDate !== null) {
          if(this.activeCPDate.id !== -1)
          cp_date = this.activeCPDate.name
        }
        let payment_amount = null;
        if(this.paymentAmount.length !== 0) {
          payment_amount = this.paymentAmount;
        }
        let type = "payment";
        if(this.$route.fullPath.indexOf("accounting-invoice") >= 0) {
          type = "invoice";
        }
        let ports = [];
        if(this.port.length !== 0) {
          ports = this.port.map(a=> {
            return a.id
          })
        }
        let statement_member = "";
        if(this.activeCPDateDefStatement) {
          statement_member = this.activeCPDateDefStatement.name
        }
        let account = []
        if(Array.isArray(this.activeAccountName) === true) {
          account = this.activeAccountName.map(a=> {
            return a.id
          })
        }
        let saveObj = {
          data_type: type, 
          ports: ports,
          payment_type: payment_type, 
          currency: this.activeValuePayment.name, 
          currency_amount: this.paymentAmountConvert,
          payment_amount: payment_amount, 
          execute_date: this.dueDate, 
          status: "not_paid", 
          is_archive: false, 
          client: counterpatryID,
          real_account: idReal, 
          comment: this.remark, 
          cash: cash, 
          bank: bank, 
          account: account,
          file: file, 
          ship: vessel, 
          settled_ship: settled_ship, 
          cp_date: cp_date,
          linked_payments: this.linked_payments.map(el=>el.id),
          linked_owners: this.linked_owners.map(el=>el.id),
          linked_invoices: this.linked_invoices.map(el=>el.id),
          statement_member: statement_member,
      }

        this.axiosCreatePayment(saveObj).then(()=> {
          this.closeModal();
          this.$emit("needRender");
        });
      // }
    },
    getPorts() {
      if(this.ports !== null) {
        return this.ports;
      } else {
        return [];
      }
    }
  },
  mounted() {
    // if(!this.getContracts.length) {
    //   this.axiosGetAllContracts();
    // }
    // if(!this.clients.length) {
    //   this.axiosGetClientsForDropdown();
    // }
    // this.axiosGetPaymentCash();
    // this.axiosGetPaymentAccount();
  }
}
</script>

<style scoped lang="scss">
  @import "payment-modal-create";
</style>